import React, { useEffect } from 'react';
import { companyInfo } from '../data/mock';

const ImpressumPage = () => {
  useEffect(() => {
    document.title = 'Impressum | Helper-Schweiz - Entrümpelung Deutschschweiz';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', 'Impressum von Helper-Schweiz. Inhaber: Christian Reinhardt, Seestrasse 45, 8596 Scherzingen, Thurgau. UID: CHE-306.093.237');
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-[#f0f5fa] to-[#e8f0f8] py-16">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-[#1e3a5f]">Impressum</h1>
        </div>
      </section>

      {/* Impressum Content */}
      <section className="py-20">
        <div className="max-w-4xl mx-auto px-4">
          <div className="prose prose-lg max-w-none">
            <div className="space-y-8">
              
              {/* Angaben gemäss Schweizer Recht */}
              <div className="bg-[#f8fafc] rounded-2xl p-8">
                <h2 className="text-2xl font-bold text-[#1e3a5f] mb-4">Angaben gemäss Art. 3 UWG</h2>
                <div className="space-y-2 text-gray-600">
                  <p className="font-semibold text-[#1e3a5f] text-lg">{companyInfo.name}</p>
                  <p>{companyInfo.owner}</p>
                  <p>{companyInfo.address}</p>
                  <p>Schweiz</p>
                </div>
              </div>

              {/* Kontakt */}
              <div>
                <h2 className="text-2xl font-bold text-[#1e3a5f] mb-4">Kontakt</h2>
                <div className="space-y-2 text-gray-600">
                  <p><strong>Telefon:</strong> {companyInfo.phone}</p>
                  <p><strong>E-Mail:</strong> <a href={`mailto:${companyInfo.email}`} className="text-[#1e3a5f] hover:text-[#c41e3a]">{companyInfo.email}</a></p>
                  <p><strong>Website:</strong> <a href="https://helper-schweiz.ch" className="text-[#1e3a5f] hover:text-[#c41e3a]">www.helper-schweiz.ch</a></p>
                </div>
              </div>

              {/* Unternehmensform */}
              <div>
                <h2 className="text-2xl font-bold text-[#1e3a5f] mb-4">Unternehmensform</h2>
                <p className="text-gray-600">Einzelunternehmen</p>
                <p className="text-gray-600 mt-2"><strong>UID-Nummer:</strong> CHE-306.093.237</p>
              </div>

              {/* MwSt */}
              <div>
                <h2 className="text-2xl font-bold text-[#1e3a5f] mb-4">Mehrwertsteuer</h2>
                <p className="text-gray-600">
                  Nicht MwSt-pflichtig gemäss Art. 10 Abs. 2 lit. a MWSTG (Mehrwertsteuergesetz). Der Jahresumsatz liegt unter CHF 100'000.
                </p>
              </div>

              {/* Verantwortlich für den Inhalt */}
              <div>
                <h2 className="text-2xl font-bold text-[#1e3a5f] mb-4">Verantwortlich für den Inhalt</h2>
                <div className="space-y-1 text-gray-600">
                  <p>{companyInfo.owner}</p>
                  <p>{companyInfo.address}</p>
                </div>
              </div>

              {/* Haftungsausschluss */}
              <div>
                <h2 className="text-2xl font-bold text-[#1e3a5f] mb-4">Haftungsausschluss</h2>
                <div className="space-y-4 text-gray-600">
                  <p>
                    Der Autor übernimmt keine Gewähr für die Richtigkeit, Genauigkeit, Aktualität, Zuverlässigkeit und Vollständigkeit der Informationen.
                  </p>
                  <p>
                    Haftungsansprüche gegen den Autor wegen Schäden materieller oder immaterieller Art, die aus dem Zugriff oder der Nutzung bzw. Nichtnutzung der veröffentlichten Informationen, durch Missbrauch der Verbindung oder durch technische Störungen entstanden sind, werden ausgeschlossen.
                  </p>
                  <p>
                    Alle Angebote sind freibleibend. Der Autor behält es sich ausdrücklich vor, Teile der Seiten oder das gesamte Angebot ohne gesonderte Ankündigung zu verändern, zu ergänzen, zu löschen oder die Veröffentlichung zeitweise oder endgültig einzustellen.
                  </p>
                </div>
              </div>

              {/* Haftungsausschluss für Links */}
              <div>
                <h2 className="text-2xl font-bold text-[#1e3a5f] mb-4">Haftungsausschluss für Links</h2>
                <p className="text-gray-600">
                  Verweise und Links auf Webseiten Dritter liegen ausserhalb unseres Verantwortungsbereichs. Es wird jegliche Verantwortung für solche Webseiten abgelehnt. Der Zugriff und die Nutzung solcher Webseiten erfolgen auf eigene Gefahr des jeweiligen Nutzers.
                </p>
              </div>

              {/* Urheberrechte */}
              <div>
                <h2 className="text-2xl font-bold text-[#1e3a5f] mb-4">Urheberrechte</h2>
                <p className="text-gray-600">
                  Die Urheber- und alle anderen Rechte an Inhalten, Bildern, Fotos oder anderen Dateien auf dieser Website gehören ausschliesslich {companyInfo.name} oder den speziell genannten Rechteinhabern. Für die Reproduktion jeglicher Elemente ist die schriftliche Zustimmung des Urheberrechtsträgers im Voraus einzuholen.
                </p>
              </div>

              {/* Datenschutz */}
              <div>
                <h2 className="text-2xl font-bold text-[#1e3a5f] mb-4">Datenschutz</h2>
                <p className="text-gray-600">
                  Gestützt auf Artikel 13 der Schweizerischen Bundesverfassung und die datenschutzrechtlichen Bestimmungen des Bundes hat jede Person Anspruch auf Schutz ihrer Privatsphäre sowie auf Schutz vor Missbrauch ihrer persönlichen Daten. Wir halten diese Bestimmungen ein. Persönliche Daten werden streng vertraulich behandelt und weder an Dritte verkauft noch weitergegeben.
                </p>
              </div>

              {/* Stand */}
              <div className="pt-8 border-t">
                <p className="text-gray-500 text-sm">
                  Stand: 2026
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ImpressumPage;
